// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'diarias.lancar.abrir': 'Lançar Diária',
    'diarias.lancar.titulo': 'Lançar Diária',
    'diarias.lancar.nome': 'Nome',
    'diarias.lancar.buscarNome': 'Buscar nome ou matrícula…',
    'diarias.lancar.funcaoNaBase': '{{funcao}} em {{base}}',
    'diarias.lancar.lancamento': 'Lançamento',
    'diarias.lancar.tipo': 'Tipo',
    'diarias.lancar.de': 'De',
    'diarias.lancar.ate': 'Até',
    'diarias.lancar.motivo': 'Motivo',
    'diarias.lancar.motivoDica': 'Obrigatório. Vai na coluna Motivo do CSV do Protheus.',
    'diarias.lancar.colMotivo': 'Motivo',
    'diarias.lancar.motivoPendente': 'Informe o motivo',
    'diarias.lancar.confirmar': 'Lançar',
    'diarias.lancar.lancando': 'Lançando…',
    'diarias.lancar.lancado_one': 'Diária lançada em {{count}} dia. Ela já aparece no Painel de Lançamento.',
    'diarias.lancar.lancado_other': 'Diária lançada em {{count}} dias. Elas já aparecem no Painel de Lançamento.',
  },
  en: {
    'diarias.lancar.abrir': 'Log daily allowance',
    'diarias.lancar.titulo': 'Log daily allowance',
    'diarias.lancar.nome': 'Name',
    'diarias.lancar.buscarNome': 'Search name or employee ID…',
    'diarias.lancar.funcaoNaBase': '{{funcao}} at {{base}}',
    'diarias.lancar.lancamento': 'Entry',
    'diarias.lancar.tipo': 'Type',
    'diarias.lancar.de': 'From',
    'diarias.lancar.ate': 'To',
    'diarias.lancar.motivo': 'Reason',
    'diarias.lancar.motivoDica': 'Required. It goes in the Reason column of the Protheus CSV.',
    'diarias.lancar.colMotivo': 'Reason',
    'diarias.lancar.motivoPendente': 'Enter the reason',
    'diarias.lancar.confirmar': 'Log',
    'diarias.lancar.lancando': 'Logging…',
    'diarias.lancar.lancado_one': 'Daily allowance logged for {{count}} day. It is already on the Entry Board.',
    'diarias.lancar.lancado_other': 'Daily allowance logged for {{count}} days. They are already on the Entry Board.',
  },
  es: {
    'diarias.lancar.abrir': 'Registrar viático',
    'diarias.lancar.titulo': 'Registrar viático',
    'diarias.lancar.nome': 'Nombre',
    'diarias.lancar.buscarNome': 'Buscar nombre o legajo…',
    'diarias.lancar.funcaoNaBase': '{{funcao}} en {{base}}',
    'diarias.lancar.lancamento': 'Registro',
    'diarias.lancar.tipo': 'Tipo',
    'diarias.lancar.de': 'Desde',
    'diarias.lancar.ate': 'Hasta',
    'diarias.lancar.motivo': 'Motivo',
    'diarias.lancar.motivoDica': 'Obligatorio. Va en la columna Motivo del CSV de Protheus.',
    'diarias.lancar.colMotivo': 'Motivo',
    'diarias.lancar.motivoPendente': 'Informe el motivo',
    'diarias.lancar.confirmar': 'Registrar',
    'diarias.lancar.lancando': 'Registrando…',
    'diarias.lancar.lancado_one': 'Viático registrado en {{count}} día. Ya aparece en el Panel de Registro.',
    'diarias.lancar.lancado_other': 'Viático registrado en {{count}} días. Ya aparecen en el Panel de Registro.',
  },
}
